import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import * as staffAPI from "../../api/staff";

export const initialState = {
  status: null,
  loading: false,
  data: [],
  staffAttendanceList: [],
  activeStaff: null,
  activeProfileImage: null,
  staffPersonalInfo: {},
  // staffEducationInfomartion: {},
  // staffEmploymentInformation: {},
  // staffCertificationInformation: {},
  // staffAchievmentsInformation: {},
  perPage: 10,
  page: 1,
  offset: 0,
  staffInterestsInformation: {},
  employmentInformation: [
    {
      startDate: null,
      endDate: null,
      college: null,
      address: null,
      idFaculty: null,
    },
  ],
  educationInformation: [
    {
      type: null,
      course: null,
      completedYear: null,
      college: null,
      address: null,
      university: null,
      aggregate: null,
      idFaculty: null,
      id: "",
    },
  ],
  certification: [
    {
      certificationName: null,
      certificationBody: null,
      certifiedYear: null,
      aggregate: null,
      idFaculty: null,
      id: "",
    },
  ],
  achievement: [
    {
      awardName: null,
      level: null,
      awardYear: null,
      type: null,
      idFaculty: null,
      id: "",
    },
  ],
  interest: [
    {
      id: "",
      type: null,
      description: null,
      idFaculty: null,
    },
  ],
  facultyData: null,
  profileCompleteness: 0,
  facultyAttendance: [],
};

const addStaffInfo = createAsyncThunk(
  "staff/addStaffInfo",
  async (params, { rejectWithValue, state }) => {
    const payload = {
      id: "",
      regNumber: params.staffPersonalInfo.regNumber,
      firstName: params.staffPersonalInfo.firstName,
      lastName: params.staffPersonalInfo.lastName,
      email: params.staffPersonalInfo.email,
      designation: params.staffPersonalInfo.designation,
      idRole: "1",
      idDepartment: params.staffPersonalInfo.idDepartment,
      dob: params.staffPersonalInfo.dob,
      bloodGroup: params.staffPersonalInfo.bloodGroup,
      phone: params.staffPersonalInfo.phone,
      address: params.staffPersonalInfo.address,
      experience: params.staffPersonalInfo.experience,
      institutionId:params.staffPersonalInfo.institutionId
    };
    try {
      const res = await staffAPI.staffPersonal(payload);
      if (res.data.statusCodeValue >= 400) {
        // toast.error(res.data.body.error)
        return rejectWithValue(res.data.body.error);
      }
      // state.staffPersonalInfo = {...params};
      return res.data;
    } catch (error) {}
  }
);

const updateStaff = createAsyncThunk(
  "staff/update/personal",
  async (params, { rejectWithValue, state }) => {
    try {
      const res = await staffAPI.updateStaff(params);

      if (res.data.statusCodeValue >= 400) {
        // toast.error(res.data.body.error)
        return rejectWithValue(res.data.body.error);
      }
      getStaffInfo(params?.staffPersonalInfo?.id);
      // state.staffPersonalInfo = {...params};
      return res.data;
    } catch (error) {}
  }
);

const addStaffEducationInformation = createAsyncThunk(
  "faculty/facultyEducationInfo",
  async (params, { rejectWithValue }) => {
    const payload = {
      type: params?.type,
      course: params?.course,
      completedYear: params?.completedYear,
      college: params?.college,
      university: params?.university,
      address: params?.address,
      aggregate: params?.aggregate,
      idFaculty: params?.idFaculty,
      id: params?.id,
    };
    try {
      const res = await staffAPI.staffEducationInformation(params);
      if (res.data.statusCodeValue >= 400) {
        // toast.error(res.data.body.error)
        return rejectWithValue(res.data.body.error);
      }
      return res.data;
    } catch (error) {}
  }
);

const addStaffEmploymentInformation = createAsyncThunk(
  "faculty/employmentHistory",
  async (params, { rejectWithValue }) => {
    try {
      const payload = {
        college: params?.college,
        address: params?.address,
        designation: params?.designation,
        startDate: params?.startDate,
        endDate: params?.endDate,
        idFaculty: params?.idFaculty,
        id: params?.id,
      };
      const res = await staffAPI.staffEmploymentInformation(params);
      if (res.data.statusCodeValue >= 400) {
        // toast.error(res.data.body.error)
        return rejectWithValue(res.data.body.error);
      }
      return res.data;
    } catch (error) {}
  }
);

const addStaffCertificationInformation = createAsyncThunk(
  "faculty/certificate",
  async (params, { rejectWithValue }) => {
    const payload = {
      certificationName: params?.certificationName,
      certifiedYear: params?.certifiedYear,
      certificationBody: params?.certificationBody,
      aggregate: params?.aggregate,
      idFaculty: params?.idFaculty,
      id: params?.id,
    };
    try {
      const res = await staffAPI.staffCertificationInformation(params);
      if (res.data.statusCodeValue >= 400) {
        // toast.error(res.data.body.error)
        return rejectWithValue(res.data.body.error);
      }
      return res.data;
    } catch (error) {}
  }
);

const addStaffAchievmentsInformation = createAsyncThunk(
  "faculty/achievements",
  async (params, { rejectWithValue }) => {
    const payload = {
      type: params?.type,
      level: params?.level,
      awardName: params?.awardName,
      awardYear: params?.awardYear,
      idFaculty: params?.idFaculty,
      id: params?.id,
    };
    try {
      const res = await staffAPI.staffAchievmentsInformation(params);
      if (res.data.statusCodeValue >= 400) {
        // toast.error(res.data.body.error)
        return rejectWithValue(res.data.body.error);
      }
      return res.data;
    } catch (error) {}
  }
);

const addStaffInterestInformation = createAsyncThunk(
  "faculty/interests",
  async (params, { rejectWithValue }) => {
    const payload = [
      {
        type: params?.type.toString(),
        idFaculty: params?.idFaculty,
        id: params?.id,
      },
    ];
    //console.log(params, "addStaffInterestInformation");
    try {
      const res = await staffAPI.staffInterestsInformation(payload);
      if (res.data.statusCodeValue >= 400) {
        // toast.error(res.data.body.error)
        return rejectWithValue(res.data.body.error);
      }
      return res.data;
    } catch (error) {}
  }
);

const uploadProfilePic = createAsyncThunk(
  "/faculty/upload/pic",
  async (params, { rejectWithValue }) => {
    // const { ProfilePicUrl } = params;
    // const payload = {
    //   ProfilePicUrl: ProfilePicUrl,
    //   idFaculty: params?.idFaculty,
    // };
    try {
      const res = await staffAPI.uploadProfilePic(params);
      getStaffInfo(params.facultyProfilePic.idFaculty);
      if (res.data.statusCodeValue >= 400) {
        // toast.error(res.data.body.error)

        return rejectWithValue(res.data.body.error);
      }

      return res.data;
    } catch (error) {}
  }
);

const getStaffInfo = createAsyncThunk(
  "faculty/getFaculty",
  async (params, { rejectWithValue }) => {
    try {
      const res = await staffAPI.getStaffInfo(params);
      if (res.data.statusCodeValue >= 400) {
        rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {}
  }
);

const deleteFacultyInfo = createAsyncThunk(
  "staff/delete",
  async (params, { rejectWithValue }) => {
    try {
      const res = await staffAPI.deleteFacultyInfo(params);
      if (res.data.statusCodeValue >= 400) {
        // toast.error(res.data.body.error)
        return rejectWithValue(res.data.body.error);
      }

      return res.data;
    } catch (error) {}
  }
);

const deleteFacultyEducation = createAsyncThunk(
  "/delete/faculty/edu",
  async (params, { rejectWithValue }) => {
    try {
      const res = await staffAPI.deleteFacultyEducation(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }

      return res.data;
    } catch (error) {}
  }
);

const deleteFacultyEmployment = createAsyncThunk(
  "/delete/faculty/employment",
  async (params, { rejectWithValue }) => {
    try {
      const res = await staffAPI.deleteFacultyEmployment(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }

      return res.data;
    } catch (error) {}
  }
);
const deleteFacultyCertification = createAsyncThunk(
  "/delete/faculty/certification",
  async (params, { rejectWithValue }) => {
    try {
      const res = await staffAPI.deleteFacultyCertification(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }

      return res.data;
    } catch (error) {}
  }
);
const deleteFacultyAchievements = createAsyncThunk(
  "/delete/faculty/achievement",
  async (params, { rejectWithValue }) => {
    try {
      const res = await staffAPI.deleteFacultyAchievements(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }

      return res.data;
    } catch (error) {}
  }
);
const searchStaffAction = createAsyncThunk(
  "faculty/searchFaculty",
  async (params, { rejectWithValue }) => {
    try {
      const res = await staffAPI.facultySearch(params);
      return res.data?.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

// View Faculty Information Staff Screen

const facultySearch = createAsyncThunk(
  "staff/facultySearch",
  async (params, { rejectWithValue }) => {
    try {
      const res = await staffAPI.facultySearch(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getStaffAttendance = createAsyncThunk(
  "/search/staff/attendance",
  async (params, { rejectWithValue }) => {
    try {
      const res = await staffAPI.getStaffAttendance(params);
      if (res.data.statusCodeValue >= 400) {
        // alert();
        return rejectWithValue(res.data.body.error);
      }
      //console.log("getStaffAttendance", res.data.body);
      return res.data.body;
    } catch (error) {
      // alert("catch");
      return rejectWithValue(error);
    }
  }
);

const getFacultyStatusConfirmed = createAsyncThunk(
  "/get/staff/status/confirmed",
  async (params, { rejectWithValue }) => {
    try {
      const res = await staffAPI.getFacultyStatusConfirmed(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const getFacultyStatusDeleted = createAsyncThunk(
  "/get/staff/status/deleted",
  async (params, { rejectWithValue }) => {
    try {
      const res = await staffAPI.getFacultyStatusDeleted(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const staffSlice = createSlice({
  name: "staff",
  initialState: initialState,
  reducers: {
    setActiveStaff: (state, action) => {
      state.activeStaff = action.payload;
    },
    resetStaffPersonalInfo: (state) => {
      state.staffPersonalInfo = initialState.staffPersonalInfo;
      state.staffInterestsInformation = initialState.staffInterestsInformation;
      state.employmentInformation = initialState.employmentInformation;
      state.educationInformation = initialState.educationInformation;
      state.certification = initialState.certification;
      state.achievement = initialState.achievement;
      state.interest = initialState.interest;
    },
    addEducation: (state) => {
      let params = {
        type: null,
        course: null,
        completedYear: null,
        college: null,
        address: null,
        university: null,
        aggregate: null,
        idFaculty: null,
        id: "",
      };
      state.educationInformation = [...state.educationInformation, params];
    },
    removeEducation: (state, action) => {
      state.educationInformation = state.educationInformation.filter(
        (_el, index) => index !== action.payload.key
      );
    },
    addEmployment: (state) => {
      let params = {
        startDate: null,
        endDate: null,
        college: null,
        address: null,
        idFaculty: null,
      };
      state.employmentInformation = [...state.employmentInformation, params];
    },
    removeEmployment: (state, action) => {
      state.employmentInformation = state.employmentInformation.filter(
        (_el, index) => index !== action.payload.key
      );
    },
    resetProfileCompleteness: (state, action) => {
      state.profileCompleteness = 0;
    },
    addCertification: (state) => {
      let params = {
        certificationName: null,
        certificationBody: null,
        certifiedYear: null,
        aggregate: null,
        idFaculty: null,
        id: "",
      };
      state.certification = [...state.certification, params];
    },
    removeCertification: (state, action) => {
      state.certification = state.certification.filter(
        (_el, index) => index !== action.payload.key
      );
    },
    addAchievement: (state) => {
      let params = {
        awardName: null,
        level: null,
        awardYear: null,
        type: null,
        idFaculty: null,
        id: "",
      };
      state.achievement = [...state.achievement, params];
    },
    setStaffPictureUrl: (state, action) => {
      state.activeProfileImage = action.payload;
    },
    removeAchivement: (state, action) => {
      state.achievement = state.achievement.filter(
        (_el, index) => index !== action.payload.key
      );
    },
    resetPersonalInfo: (state, action) => {
      state.staffPersonalInfo = {};
    },

    //     addInterest: (state, action) => {
    // const interest = action.payload.checked.map((_el)=>{
    //   return{
    //     id:"",
    //     idFaculty:state.staffPersonalInfo.id,
    //     type: _el,
    //     description: _el,
    //   };
    // });
    // state.interest = interest;

    //     },
    setStaffProfileCompleteness: (state) => {
      if (JSON.stringify(state.staffPersonalInfo) !== "{}") {
        state.profileCompleteness = 20;
      }
      if (
        state?.educationInformation?.length > 0 &&
        state?.educationInformation?.[0]?.idFaculty?.length > 0
      ) {
        //console.log("profile==2");
        state.profileCompleteness = state.profileCompleteness + 16;
      }
      if (
        state?.employmentInformation?.length > 0 &&
        state?.employmentInformation?.[0]?.idFaculty?.length > 0
      ) {
        state.profileCompleteness = state.profileCompleteness + 16;
      }
      if (
        state?.certification?.length > 0 &&
        state?.certification?.[0]?.idFaculty?.length > 0
      ) {
        state.profileCompleteness = state.profileCompleteness + 16;
      }
      if (
        state.achievement.length > 0 &&
        state.achievement?.[0]?.idFaculty?.length > 0
      ) {
        state.profileCompleteness = state.profileCompleteness + 16;
      }
      // if(state.interest.length > 0 && state.interest?.[0]?.idFaculty.length > 0){
      //   state.profileCompleteness = state.profileCompleteness + 16;
      // }
      if (JSON.stringify(state.staffInterestsInformation) !== "[]") {
        state.profileCompleteness = state.profileCompleteness + 16;
      }
    },
    updateEductionInfoItemData: (state, action) => {
      const { type, index, data } = action.payload;
      state.educationInformation[index][type] = data;
      if (state.staffPersonalInfo) {
        state.educationInformation[index]["idFaculty"] =
          state.staffPersonalInfo?.id;
      } else {
        state.educationInformation[index]["idFaculty"] = state.activeStaff;
      }
    },
    updateEmploymentInfoItemData: (state, action) => {
      const { type, index, data } = action.payload;
      state.employmentInformation[index][type] = data;
      if (state.staffPersonalInfo) {
        state.employmentInformation[index]["idFaculty"] =
          state.staffPersonalInfo?.id;
      } else {
        state.employmentInformation[index]["idFaculty"] = state.activeStaff;
      }
    },
    updateCertificationInfoItemData: (state, action) => {
      const { type, index, data } = action.payload;
      state.certification[index][type] = data;
      if (state.staffPersonalInfo) {
        state.certification[index]["idFaculty"] = state.staffPersonalInfo.id;
      } else {
        state.certification[index]["idFaculty"] = state.activeStaff;
      }
    },
    updateAchivementsInfoItemData: (state, action) => {
      const { type, index, data } = action.payload;
      state.achievement[index][type] = data;
      if (state.staffPersonalInfo) {
        state.achievement[index]["idFaculty"] = state.staffPersonalInfo?.id;
      } else {
        state.achievement[index]["idFaculty"] = state.activeStaff;
      }
    },
    resetStaffAttendanceList: (state, action) => {
      state.facultyAttendance = [];
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setOffset: (state, action) => {
      state.offset = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(addStaffInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(addStaffInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.staffPersonalInfo = action?.payload?.body?.faculty;
        toast.success(action?.payload?.body?.success);
      })
      .addCase(addStaffInfo.rejected, (state, action) => {
        state.loading = false;
        toast.error(action.payload);
      })
      .addCase(addStaffEducationInformation.pending, (state) => {
        state.loading = true;
      })
      .addCase(addStaffEducationInformation.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload.body);
      })
      .addCase(addStaffEducationInformation.rejected, (state, action) => {
        state.loading = false;
        toast.error(action.payload);
      })
      .addCase(addStaffEmploymentInformation.pending, (state) => {
        state.loading = true;
      })
      .addCase(addStaffEmploymentInformation.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload.body);
      })
      .addCase(addStaffEmploymentInformation.rejected, (state, action) => {
        state.loading = false;
        toast.error(action.payload);
      })
      .addCase(addStaffCertificationInformation.pending, (state) => {
        state.loading = true;
      })
      .addCase(addStaffCertificationInformation.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload.body);
      })
      .addCase(addStaffCertificationInformation.rejected, (state, action) => {
        state.loading = false;
        toast.error(action.payload);
      })
      .addCase(addStaffAchievmentsInformation.pending, (state) => {
        state.loading = true;
      })
      .addCase(addStaffAchievmentsInformation.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload.body);
      })
      .addCase(addStaffAchievmentsInformation.rejected, (state, action) => {
        state.loading = false;
        toast.error(action.payload);
      })
      .addCase(addStaffInterestInformation.pending, (state) => {
        state.loading = true;
      })
      .addCase(addStaffInterestInformation.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload.body);
      })
      .addCase(addStaffInterestInformation.rejected, (state, action) => {
        state.loading = false;
        toast.error(action.payload);
      })
      .addCase(getStaffInfo.pending, (state) => {
        state.loading = true;
        state.profileCompleteness = 0;
      })
      .addCase(getStaffInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.staffPersonalInfo = action.payload?.facultyPersonalInfo;
        if (action.payload?.educationList.length > 0) {
          state.educationInformation = action.payload?.educationList;
        } else {
          state.educationInformation = initialState.educationInformation;
        }
        if (action.payload?.achievementsList.length > 0) {
          state.achievement = action.payload?.achievementsList;
        } else {
          state.achievement = initialState.achievement;
        }
        if (action.payload?.employmentHistoryList.length > 0) {
          state.employmentInformation = action.payload?.employmentHistoryList;
        } else {
          state.employmentInformation = initialState.employmentInformation;
        }
        if (action.payload?.interestList.length > 0) {
          state.interest = action.payload?.interestList;
        } else {
          state.interest = initialState.interest;
        }
        if (action.payload?.certificationsList.length > 0) {
          state.certification = action.payload?.certificationsList;
        } else {
          state.certification = initialState.certification;
        }
      })
      .addCase(getStaffInfo.rejected, (state) => {
        state.loading = false;
      })
      .addCase(searchStaffAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchStaffAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(searchStaffAction.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateStaff.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateStaff.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload.body);
        // state.staffPersonalInfo = action.payload.body;
      })
      .addCase(updateStaff.rejected, (state, action) => {
        state.loading = false;
        toast.error(action.payload);
      })
      .addCase(deleteFacultyInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFacultyInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.staffPersonalInfo = action.payload.body;
        toast.success(action.payload.body);
      })
      .addCase(deleteFacultyInfo.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteFacultyEducation.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFacultyEducation.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload.body);
      })
      .addCase(deleteFacultyEducation.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteFacultyEmployment.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFacultyEmployment.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload.body);
      })
      .addCase(deleteFacultyEmployment.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteFacultyCertification.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFacultyCertification.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload.body);
      })
      .addCase(deleteFacultyCertification.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteFacultyAchievements.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFacultyAchievements.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload.body);
      })
      .addCase(deleteFacultyAchievements.rejected, (state) => {
        state.loading = false;
      })
      .addCase(uploadProfilePic.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadProfilePic.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload.body);
      })
      .addCase(uploadProfilePic.rejected, (state) => {
        state.loading = false;
      })
      .addCase(facultySearch.pending, (state) => {
        state.loading = true;
      })
      .addCase(facultySearch.fulfilled, (state, action) => {
        state.loading = false;
        state.facultyData = action.payload;
      })
      .addCase(facultySearch.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getStaffAttendance.pending, (state) => {
        state.loading = true;
        state.facultyAttendance = [];
      })
      .addCase(getStaffAttendance.fulfilled, (state, action) => {
        state.loading = false;
        state.facultyAttendance = action.payload;
      })
      .addCase(getStaffAttendance.rejected, (state) => {
        state.loading = false;
        state.facultyAttendance = [];
      })
      .addCase(getFacultyStatusConfirmed.fulfilled, (state, action) => {
        state.loading = false;
        state.facultyData = action.payload;
      })
      .addCase(getFacultyStatusDeleted.fulfilled, (state, action) => {
        state.loading = false;
        state.facultyData = action.payload;
      });
  },
});

const {
  addEducation,
  removeEducation,
  addEmployment,
  removeEmployment,
  addCertification,
  removeCertification,
  addAchievement,
  removeAchivement,
  setActiveStaff,
  setStaffProfileCompleteness,
  setStaffPictureUrl,
  updateEductionInfoItemData,
  updateEmploymentInfoItemData,
  updateCertificationInfoItemData,
  updateAchivementsInfoItemData,
  resetProfileCompleteness,
  resetPersonalInfo,
  resetStaffPersonalInfo,
  resetStaffAttendanceList,
  setPerPage,
  setOffset,
  setPage,
} = staffSlice.actions;

export {
  addStaffInfo,
  addStaffEducationInformation,
  addStaffEmploymentInformation,
  addStaffCertificationInformation,
  addStaffAchievmentsInformation,
  addStaffInterestInformation,
  uploadProfilePic,
  addEducation,
  removeEducation,
  addEmployment,
  removeEmployment,
  addCertification,
  removeCertification,
  addAchievement,
  removeAchivement,
  getStaffInfo,
  searchStaffAction,
  setActiveStaff,
  updateStaff,
  deleteFacultyInfo,
  deleteFacultyEducation,
  deleteFacultyEmployment,
  deleteFacultyCertification,
  deleteFacultyAchievements,
  facultySearch,
  setStaffProfileCompleteness,
  getStaffAttendance,
  setStaffPictureUrl,
  updateEductionInfoItemData,
  updateEmploymentInfoItemData,
  updateCertificationInfoItemData,
  updateAchivementsInfoItemData,
  resetProfileCompleteness,
  resetPersonalInfo,
  resetStaffPersonalInfo,
  resetStaffAttendanceList,
  getFacultyStatusConfirmed,
  getFacultyStatusDeleted,
  setPerPage,
  setOffset,
  setPage,
};

export default staffSlice.reducer;
